import { css } from '@inter-ikea-kompis/web-component';

/**
 * A class with style.
 */
export default class DragAndDropItemStyle {
	/**
	 * Returns styles.
	 *
	 * @returns Styles.
	 */
	public static getStyle(): string {
		return css`
			:host {
				display: inline-block;
			}
			.ghost-container {
				position: fixed;
				transform: translate(-50%, -50%);
			}
			.item-container {
				position: relative;
				height: 100%;
			}
			.drag-container {
				position: relative;
				top: -100vh;
				left: -100vw;
				height: 200vh;
				width: 200vw;
			}
		`;
	}
}
